<template>
    <div class="custom-time-picker">
        <input ref="timePicker" type="hidden" v-model="mutableValue" />

        <div class="input-container" @click="togglePopup" ref="inputContainer">
            <input v-model="selectedHour" @input="handleHourInput" class="time-input" />
            <span>:</span>
            <input v-model="selectedMinute" @input="manualUpdateTime" class="time-input" />
            <input :value="selectedPeriodLabel" @input="handlePeriodInput" class="period-input" />

            <div class="date-icon-field" @click="togglePopup">
                <img class="date-picker-icon" src="/images/svgs/clock.svg" alt="" />
            </div>
        </div>

        <div :class="['time-picker-popup', { 'd-none': !showPopup }]" click.stop>
            <div class="scroll-container">
                <div>
                    <button type="button" @click.stop="incrementHour" class="time-picker-select-btn">
                        <img :src="brandingImagesPath('/images/svgs/search-arrow-up.svg')" alt="Up Arrow" />
                    </button>
                    <select class="time-picker-select border-0" v-model="selectedHour">
                        <option v-for="hour in hours" :key="hour" :value="hour">
                            {{ hour }}
                        </option>
                    </select>
                    <button type="button" @click.stop="decrementHour" class="time-picker-select-btn">
                        <img :src="brandingImagesPath('/images/svgs/search-arrow-down.svg')" alt="Up Arrow" />
                    </button>
                </div>

                <span>:</span>

                <div>
                    <button type="button" @click.stop="incrementMinute" class="time-picker-select-btn">
                        <img :src="brandingImagesPath('/images/svgs/search-arrow-up.svg')" alt="Up Arrow" />
                    </button>
                    <select class="time-picker-select border-0" v-model="selectedMinute">
                        <option v-for="minute in minutes" :key="minute" :value="minute">
                            {{ minute }}
                        </option>
                    </select>
                    <button type="button" @click.stop="decrementMinute" class="time-picker-select-btn">
                        <img :src="brandingImagesPath('/images/svgs/search-arrow-down.svg')" alt="Up Arrow" />
                    </button>
                </div>

                <select class="time-picker-select period-select border-0" v-model="selectedPeriod">
                    <option value="AM">{{ periodLabels.AM }}</option>
                    <option value="PM">{{ periodLabels.PM }}</option>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
import branding from '../../mixins/branding';
import { getPeriodLabels } from '../../common/flatpickrlocalizer';

export default {
    mixins: [branding],
    props: ['value', 'disabled'],
    data() {
        return {
            mutableValue: this.value,
            selectedHour: '09',
            selectedMinute: '00',
            selectedPeriod: 'AM',
            showPopup: false,
            hours: Array.from({ length: 12 }, (_, i) => String(i + 1).padStart(2, '0')),
            minutes: Array.from({ length: 12 }, (_, i) => String(i * 5).padStart(2, '0')),
        };
    },
    computed: {
        periodLabels() {
            return getPeriodLabels(window.greenmotion && window.greenmotion.locale);
        },
        selectedPeriodLabel() {
            return this.periodLabels[this.selectedPeriod] || this.selectedPeriod;
        },
    },
    watch: {
        mutableValue(newValue) {
            this.$emit('input', newValue);
        },
        selectedPeriod(newPeriod, oldPeriod) {
            if (newPeriod !== oldPeriod) {
                let hour = parseInt(this.selectedHour, 10);
                const minute = parseInt(this.selectedMinute, 10);

                hour = this.checkHourType(hour, newPeriod);

                this.mutableValue = `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
            }
        },
    },
    methods: {
        incrementHour() {
            let hour = parseInt(this.selectedHour, 10);
            hour = hour === 12 ? 1 : hour + 1;
            this.selectedHour = String(hour).padStart(2, '0');
            this.updateTime();
        },
        decrementHour() {
            let hour = parseInt(this.selectedHour, 10);
            hour = hour === 1 ? 12 : hour - 1;
            this.selectedHour = String(hour).padStart(2, '0');
            this.updateTime();
        },
        incrementMinute() {
            let minute = parseInt(this.selectedMinute, 10);
            minute = minute === 55 ? 0 : minute + 5;
            this.selectedMinute = String(minute).padStart(2, '0');
            this.updateTime();
        },
        decrementMinute() {
            let minute = parseInt(this.selectedMinute, 10);
            minute = minute === 0 ? 55 : minute - 5;
            this.selectedMinute = String(minute).padStart(2, '0');
            this.updateTime();
        },
        handleKeyPress(event) {
            if (event.key === 'Enter' && this.showPopup) {
                this.showPopup = false;
            }
        },
        handleHourInput() {
            this.selectedHour = this.selectedHour.slice(-2);
            this.manualUpdateTime();
        },
        handlePeriodInput(event) {
            const period = this.normalisePeriod(event.target.value);

            if (period) {
                this.selectedPeriod = period;
            }

            event.target.value = this.selectedPeriodLabel;
            this.manualUpdateTime();
        },
        updatePeriod() {
            console.log('updatePeriod', this.selectedPeriod);
            this.updateTime();
        },
        manualUpdateTime() {
            let hour = parseInt(this.selectedHour, 10);

            hour = this.checkHourType(hour, this.selectedPeriod);

            const minute = parseInt(this.selectedMinute, 10);

            if (!isNaN(hour) && !isNaN(minute) && hour >= 0 && hour <= 23 && minute >= 0 && minute <= 59) {
                this.mutableValue = `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;

                let period = 'AM';
                if (hour >= 12) {
                    period = 'PM';
                    hour = hour === 12 ? 12 : hour - 12;
                } else if (hour === 0) {
                    hour = 12;
                }

                this.selectedHour = String(hour).padStart(2, '0');
                this.selectedPeriod = period;
            }
        },
        updateTime() {
            let hour = parseInt(this.selectedHour, 10);

            hour = this.checkHourType(hour, this.selectedPeriod);

            const minute = parseInt(this.selectedMinute, 10);

            if (!isNaN(hour) && !isNaN(minute) && hour >= 0 && hour <= 23 && minute >= 0 && minute <= 59) {
                this.mutableValue = `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;

                let period = 'AM';
                if (hour >= 12) {
                    period = 'PM';
                    hour = hour === 12 ? 12 : hour - 12;
                } else if (hour === 0) {
                    hour = 12;
                }

                this.selectedHour = String(hour).padStart(2, '0');
                const currentPeriod = this.selectedPeriod;
                this.selectedPeriod = currentPeriod;
            }
        },
        togglePopup() {
            this.showPopup = !this.showPopup;
            if (this.showPopup) {
                document.addEventListener('click', this.handleClickOutside);
            } else {
                document.removeEventListener('click', this.handleClickOutside);
            }
        },
        handleClickOutside(event) {
            if (!this.$el.contains(event.target) && !event.target.classList.contains('arrow-button')) {
                this.showPopup = false;
            }
        },
        normalisePeriod(period) {
            const value = String(period || '').trim().toLowerCase();

            if (value === 'am' || value === String(this.periodLabels.AM).toLowerCase()) {
                return 'AM';
            }

            if (value === 'pm' || value === String(this.periodLabels.PM).toLowerCase()) {
                return 'PM';
            }

            return null;
        },
        checkHourType(hour, period) {
            let newHour = hour;

            if (period === 'AM') {
                newHour = hour === 12 ? 0 : hour;
            }

            if (period === 'PM') {
                newHour = hour === 12 ? 12 : hour + 12;
            }

            return newHour;
        },
    },
    mounted() {
        document.addEventListener('keyup', this.handleKeyPress);
    },
    beforeDestroy() {
        document.removeEventListener('keyup', this.handleKeyPress);
    },
};
</script>

<style scoped>
.time-picker {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.input-container {
    display: flex;
    align-items: center;
    cursor: pointer;
}

.time-input,
.period-input {
    width: 27px;
    text-align: center;
    border: 0;
    color: rgb(72, 72, 72);
}

.period-input {
    width: 36px;
}

.time-picker-select {
    background-color: #ffffff;
    padding: 0.3em 0.5em;
    border: none;
    display: flex;
    align-items: center;
}

.period-select {
    min-width: 42px;
}
.time-picker-select-btn {
    background-color: #ffffff;
    padding: 0 1em;
    border: none;
    display: flex;
    align-items: center;
}

.time-picker-select:focus {
    border: none;
    outline: none;
}

.time-picker-popup,
.time-picker-popup select,
.time-picker-popup button {
    color: rgb(72, 72, 72);
}

.time-picker-popup {
    position: absolute;
    background-color: #ffffff;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 2px;
    z-index: 100;
}

.scroll-container {
    display: flex;
    align-items: center;
}

select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url('data:image/svg+xml;charset=UTF-8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="%23777"><path d="M8 0L0 10h16L8 0z"/></svg>');
    background-position: right 10px top 50%, 0 0;
    background-size: 0;
    padding-right: 1em;
}

.date-icon-field {
    margin-left: auto;
}

.date-picker-icon {
    width: 16px;
    height: 16px;
}

button {
    background-color: transparent;
    border: none;
    cursor: pointer;
    font-size: 12px;
    line-height: 1;
    padding: 0;
    margin: 0;
}

input:focus,
select:focus {
    outline: none;
    border: 1px solid #ccc;
}
</style>
